import { useEffect } from 'react';
import { useAppDispatch } from '@/store';
import { checkAuthentication } from '@/store/thunks/authThunks';
import Router from '@/routes';
import { Toast } from '@/components/Toast';

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(checkAuthentication());
  }, [dispatch]);

  return (
    <>
      <Toast />
      <Router />
    </>
  );
}

export default App;
